module.exports = __webpack_public_path__ + "static/img/CC5.80b5492.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CC5.png
// module id = ToDC
// module chunks = 0